import request from "@/utils/request";
const Qs = require("qs");

export function login(data) {
  return request({
    url: "/auth/oauth/token",
    method: "post",
    data
  });
}

export function loginByUsername(data) {
  return request({
    url: "/auth/oauth/token",
    method: "post",
    headers: {
      Authorization: "Basic d2ViLWFwcDpycTludU5rSXdU"
    },
    transformRequest: [
      function(data) {
        return Qs.stringify(data);
      }
    ],
    data
  });
}

export function logout() {
  return request({
    url: "/login/logout",
    method: "post"
  });
}

// 获取 登录人 权限
export function findRoleByToken() {
  return request({
    url: "/org/findRoleByToken",
    method: "get"
  });
}

// 修改登录人密码
export function updatePwd(data) {
  return request({
    url: `/org/updatePwd`,
    method: "post",
    data
  });
}

// 修改头像
export function uploadAvatar(data) {
  return request({
    url: `/org/uploadAvatar`,
    method: "post",
    data
  });
}

// 获取未读消息条数  返回 msgUnRead-消息未读，noticeUnRead-公告未读，backlog通知未读
export function findMsgAndNoticeUnRead(data) {
  return request({
    url: `/msg/findMsgAndNoticeUnRead`,
    method: "get",
    data
  });
}

// 获取用户项目
export function findUserProject(postId) {
  return request({
    url: `/org/findUserProject/${postId}`,
    method: "get"
  });
}

// export function getUserInfo(token) {
//   return request({
//     url: '/user/info',
//     method: 'get',
//     params: { token }
//   })
// }
